import { ResourceBuilder } from '@salsita-ai/platform-project-sdk/domain';
import { adminDomainBuilder, adminInvariantBuilder, implementAdminCustomExpressions } from './__generated/admin-implementation.js';
import { generatedConfiguratorBuilder } from './__generated/configurator-builder.js';
import { domainBuilder, invariantBuilder } from './__generated/implementation.js';
import { migrateAdmin } from './admin-migrations/index.js';
import { invariantExpressions } from './implementations/invariants.js';
import { priceExpressions } from './implementations/price.js';
import { renderingExpressions } from './implementations/rendering.js';
import { sidebarExpressions } from './implementations/sidebar.js';
import { migrate } from './migrations/index.js';
const violationExpressions = invariantBuilder.withInvariants(invariantExpressions).buildViolationExpressions();
export const domainFactory = domainBuilder.withExpressions(violationExpressions).withExpressions(renderingExpressions).withExpressions(sidebarExpressions).withExpressions(priceExpressions).withMigrate(migrate).build();
const adminViolationExpressions = adminInvariantBuilder.buildViolationExpressions();
const adminCustomExpressions = implementAdminCustomExpressions({});
const adminDomainFactory = adminDomainBuilder.withExpressions(adminViolationExpressions).withExpressions(adminCustomExpressions).withMigrate(migrateAdmin).build();
const resources = new ResourceBuilder().addClientGeneratedImage({
    type: 'Image',
    name: 'clientGeneratedImage',
    s3Key: `clientGeneratedImage`,
    clientGenerated: true
}).build();
export const configuratorBuilder = generatedConfiguratorBuilder.withDomainFactory(domainFactory).withAdminDomainFactory(adminDomainFactory).withResources(resources);
export * as ApplicationTypes from './__generated/application-types.js';
export * as EnhancedDomain from './__generated/enhanced-model.js';
export * as Model from './__generated/model/index.js';
export * as AdminEnhancedDomain from './__generated/admin-enhanced-model.js';
export * as AdminModel from './__generated/admin-model/index.js';
export { createPresets } from './__generated/presets.js';
export { createAdminPresets } from './__generated/admin-presets.js';
export { attachComponent, createRecipe } from './__generated/implementation.js';
export { attachAdminComponent, createAdminRecipe } from './__generated/admin-implementation.js';
export { computeStandardProductHashes, matchesStandardProductHashes } from './standard-product/standard-product-hash.js';
export { mapStandardProductsToPublishedData } from './standard-product/map-standard-products-to-published-data.js';

//# sourceMappingURL=index.js.map